import { posts, BlogPost } from "./generated/posts";
import { localeForLang } from "./i18n";

export type { BlogPost };

function byDateAsc(a: BlogPost, b: BlogPost) {
	if (a.date !== b.date) return a.date < b.date ? -1 : 1;
	return a.slug.localeCompare(b.slug);
}

export function getPublishedPosts(lang: string): BlogPost[] {
	return posts
		.filter((post) => post.lang === lang || post.lang === "all")
		.sort((a, b) => -byDateAsc(a, b));
}

export function getPost(slug: string, lang: string): BlogPost | undefined {
	return getPublishedPosts(lang).find((post) => post.slug === slug);
}

/** 01 is the oldest post in this language; numbers stay stable as new notes land. */
export function postNumberByDate(list: BlogPost[], slug: string) {
	const index = [...list]
		.sort(byDateAsc)
		.findIndex((post) => post.slug === slug);
	return index >= 0 ? index + 1 : 0;
}

export function groupPostsByMonth(list: BlogPost[], lang: string) {
	const groups: { key: string; label: string; posts: BlogPost[] }[] = [];
	list.forEach((post) => {
		const date = new Date(`${post.date}T00:00:00`);
		const key = `${date.getFullYear()}-${date.getMonth()}`;
		const label = date.toLocaleDateString(localeForLang(lang), {
			month: "long",
			year: "numeric",
		});
		const existing = groups.find((group) => group.key === key);
		if (existing) {
			existing.posts.push(post);
		} else {
			groups.push({ key, label, posts: [post] });
		}
	});
	return groups;
}
